import styled from "styled-components";
import { workTypeDesignTokens as tokens } from "../../../work-type-shared/work-type-design-tokens";

export const PolicyPanel = styled.section`
  display: grid;
  gap: ${tokens.spacing.md};
  min-width: 0;
  padding: ${tokens.spacing.md};
  color: ${tokens.color.text};
`;

export const SelectorCard = styled.header`
  display: grid;
  gap: ${tokens.spacing.sm};
  padding: ${tokens.spacing.md};
  border: 1px solid ${tokens.color.border};
  border-radius: ${tokens.radius.card};
  background: ${tokens.color.surface};

  label {
    color: ${tokens.color.text};
    font-weight: 700;
  }

  select {
    width: 100%;
    min-height: ${tokens.control.height};
    box-sizing: border-box;
    padding: 0 12px;
    border: 1px solid ${tokens.color.borderStrong};
    border-radius: ${tokens.radius.control};
    background: ${tokens.color.surface};
    color: ${tokens.color.text};
  }

  select:focus-visible,
  button:focus-visible {
    outline: ${tokens.focus.outline};
    outline-offset: ${tokens.focus.offset};
  }

  p {
    margin: 0;
    color: ${tokens.color.textMuted};
    line-height: 1.55;
  }
`;

export const StatusPanel = styled.section<{ $tone?: "neutral" | "danger" }>`
  display: grid;
  justify-items: start;
  gap: ${tokens.spacing.sm};
  min-width: 0;
  padding: ${tokens.spacing.lg};
  border: 1px ${props => props.$tone === "danger" ? "solid" : "dashed"}
    ${props => props.$tone === "danger" ? tokens.tone.danger.border : tokens.tone.neutral.border};
  border-radius: ${tokens.radius.card};
  background: ${props => props.$tone === "danger" ? tokens.tone.danger.background : tokens.tone.neutral.background};
  color: ${props => props.$tone === "danger" ? tokens.tone.danger.text : tokens.tone.neutral.text};

  h3,
  p {
    margin: 0;
  }

  h3 {
    color: ${tokens.color.text};
  }

  p {
    line-height: 1.55;
  }

  button {
    min-height: ${tokens.control.compactHeight};
    padding: 0 14px;
    border: 1px solid ${tokens.color.borderStrong};
    border-radius: ${tokens.radius.control};
    background: ${tokens.color.surface};
    color: ${tokens.color.text};
    font-weight: 700;
  }
`;

export const EmptyIcon = styled.span`
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${tokens.color.surface};
  color: ${tokens.tone.active.text};
  font-size: 18px;
`;

export const SelectionState = styled.strong<{ $changed?: boolean }>`
  padding: 4px 9px;
  border-radius: ${tokens.radius.pill};
  background: ${props => props.$changed ? tokens.tone.selected.background : tokens.color.surface};
  color: ${props => props.$changed ? tokens.tone.selected.text : tokens.color.textMuted};
  font-size: 12px;
`;

export const WarningText = styled.p`
  color: ${tokens.tone.danger.text} !important;
  font-weight: 700;
`;
